import { MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WhatsAppWidget = () => {
  const { language } = useLanguage();
  
  const whatsappNumber = "7576503192";
  const whatsappMessage = language === 'en' 
    ? "Hello! I'd like to schedule a plumbing service."
    : "¡Hola! Me gustaría agendar un servicio de plomería.";
  
  const whatsappUrl = `https://wa.me/1${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 flex flex-col gap-3 z-50">
      {/* Call Button */}
      <a
        href="tel:+17576503192"
        className="w-12 h-12 md:w-14 md:h-14 bg-[#0F172A] text-white shadow-lg hover:bg-[#1E293B] hover:shadow-xl transition-all duration-300 flex items-center justify-center rounded-full hover:scale-110"
        data-testid="call-widget"
        aria-label={language === 'en' ? 'Call us' : 'Llámanos'}
      >
        <Phone className="w-5 h-5 md:w-6 md:h-6" />
      </a>
      
      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 md:w-14 md:h-14 bg-[#25D366] text-white shadow-lg hover:bg-[#128C7E] hover:shadow-xl transition-all duration-300 flex items-center justify-center rounded-full hover:scale-110"
        data-testid="whatsapp-widget"
        aria-label={language === 'en' ? 'Contact us on WhatsApp' : 'Contáctanos por WhatsApp'}
      >
        <MessageCircle className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" />
      </a>
    </div>
  );
};

export default WhatsAppWidget;